import {buildTourProgressElement, postJson} from './product-tours.js'

export const PHI_SAFE_TOUR_EVENT = 'cpm:tour:phi-redacted'
const TOUR_ID = 'phi-redacted'

const indicatorSelector = '[data-cy="phi-safe-indicator"]'
const menuSelector = '[data-phi-visibility-menu]'
const toggleSelector = '[data-cy="phi-visibility-toggle"]'
let activeTour = null

function tourButton(action, text, classes = '') {
    return {action, classes, text}
}

function buildStepContent(step, index, total, documentObject) {
    const content = documentObject.createElement('div')
    content.append(buildTourProgressElement(index, total, documentObject))

    const body = documentObject.createElement('p')
    body.className = 'nurse-performance-tour-body'
    body.textContent = step.text
    content.append(body)

    return content
}

export function startPhiSafeTour(browserWindow, documentObject, ShepherdLibrary) {
    if (activeTour || ShepherdLibrary.activeTour) {
        return false
    }

    const menuWrapper = documentObject.querySelector(menuSelector)
    const menu = menuWrapper?.querySelector('.dropdown-container')
    const menuTrigger = menuWrapper?.querySelector('[dropdown-trigger]')
    const toggle = menuWrapper?.querySelector(toggleSelector)

    if (!menuWrapper || !menu || !menuTrigger || !toggle) {
        return false
    }

    const setMenuOpen = (open) => {
        const menuState = browserWindow.Alpine?.$data(menu)

        if (menuState) {
            menuState.open = open
        } else {
            menuTrigger.click()
        }
    }

    menu.setAttribute('data-tour', 'true')
    setMenuOpen(true)

    const tour = new ShepherdLibrary.Tour({
        defaultStepOptions: {
            cancelIcon: {enabled: true},
            classes: 'nurse-performance-tour',
            modalOverlayOpeningPadding: 10,
            modalOverlayOpeningRadius: 16,
            scrollTo: {behavior: 'smooth', block: 'center'},
        },
        exitOnEsc: true,
        exitOnOverlayClick: true,
        useModalOverlay: true,
    })
    activeTour = tour

    const steps = []
    const indicator = documentObject.querySelector(indicatorSelector)

    if (indicator) {
        steps.push({
            id: 'phi-safe-status',
            selector: indicatorSelector,
            position: 'bottom-end',
            title: 'PHI Redacted is active',
            text: 'This shield confirms that patient identifiers are hidden. Clinical details remain available so you can keep working normally.',
        })
    }

    steps.push(
        {
            id: 'phi-safe-account-menu',
            selector: menuSelector,
            position: 'bottom-end',
            title: 'Your privacy control is always nearby',
            text: 'Open your account menu in the upper-right whenever you need to change PHI visibility.',
        },
        {
            id: 'phi-safe-switch',
            selector: toggleSelector,
            position: 'left',
            title: 'Reveal identifiers only when needed',
            text: 'Turn PHI visibility on temporarily when your work requires patient identifiers. The current page updates in place, and PHI returns to redacted the next time you sign in.',
        },
    )

    steps.forEach((step, index) => {
        const isFirst = index === 0
        const isLast = index === steps.length - 1
        const buttons = []

        buttons.push(isFirst
            ? tourButton(() => tour.cancel(), 'Not now', 'shepherd-button-secondary')
            : tourButton(() => tour.back(), 'Back', 'shepherd-button-secondary'))
        buttons.push(tourButton(
            () => isLast ? tour.complete() : tour.next(),
            isLast ? 'Done' : (isFirst ? 'Start tour' : 'Next'),
        ))

        tour.addStep({
            id: step.id,
            attachTo: {element: step.selector, on: step.position},
            buttons,
            text: buildStepContent(step, index, steps.length, documentObject),
            title: step.title,
        })
    })

    const cleanup = () => {
        menu.removeAttribute('data-tour')
        setMenuOpen(false)
        if (activeTour === tour) {
            activeTour = null
        }
    }

    tour.on('complete', () => {
        cleanup()
        postJson(browserWindow, `/tours/${TOUR_ID}/complete`)
    })
    tour.on('cancel', () => {
        cleanup()
        postJson(browserWindow, `/tours/${TOUR_ID}/dismiss`)
    })

    browserWindow.setTimeout(() => tour.start(), 200)

    return true
}

export function registerPhiSafeTour(browserWindow, documentObject, ShepherdLibrary) {
    const start = () => startPhiSafeTour(browserWindow, documentObject, ShepherdLibrary)

    browserWindow.addEventListener(PHI_SAFE_TOUR_EVENT, start)

    return () => browserWindow.removeEventListener(PHI_SAFE_TOUR_EVENT, start)
}
